/**
 * Decode HTML entities in a string using the browser's native HTML parser.
 * Handles all named and numeric entities (&#039; &amp; &quot; &lt; &gt; etc.)
 * without maintaining a manual list of replacements.
 *
 * Returns plain text — use html-react-parser's parse() for rendering HTML.
 */
export const decodeHtmlEntities = (str) => {
  if (!str || typeof str !== 'string') return str;
  const el = document.createElement('textarea');
  el.innerHTML = str;
  return el.value;
};

/**
 * Recursively decode HTML entities in all string values of a plain object.
 */
export const decodeObjectStrings = (obj) => {
  if (!obj || typeof obj !== 'object') return obj;
  const out = {};
  for (const [k, v] of Object.entries(obj)) {
    out[k] = typeof v === 'string' ? decodeHtmlEntities(v) : v;
  }
  return out;
};
